import { takeReduxPersisted } from '@/lib/takeReduxPersisted';
import { createStore, persist } from 'cross-state';

export const demoSessionStore = createStore({ showDemoSessions: false });

const persistence = persist(demoSessionStore, { id: 'demoSession', storage: localStorage });

void persistence.initialized.then(() => {
    const legacy = takeReduxPersisted('isDemoModeOn');
    if (typeof legacy?.showDemoSessions === 'boolean') {
        demoSessionStore.set('showDemoSessions', legacy.showDemoSessions);
    }
});

export const setShowDemoSessions = (value: boolean) => demoSessionStore.set('showDemoSessions', value);
